import { z } from "zod";

export const bookSchema = z.object({
  isbn: z.string(),
  title: z.string(),
  levels: z.array(z.number()),

  type: z.string().optional().nullable(),
  origin: z.string().optional().nullable(),
  sector: z.number().optional().nullable(),
  subtitle: z.string().optional().nullable(),
  edition: z.string().optional().nullable(),
  publishing_city: z.string().optional().nullable(),
  publishing_country: z.string().optional().nullable(),

  categories: z.array(z.number()).optional().nullable(),
  agreements: z.array(z.number()).optional().nullable(),
  contributors: z.array(z.number()).optional().nullable(),


  month_featured_year: z.number().optional().nullable(),
  month_featured: z.number().optional().nullable(),

  cover: z.any().optional().nullable(),
  file: z.any().optional().nullable(),

  description: z.string().optional().nullable(),
  author_biography: z.string().optional().nullable(),

  max_number_of_rental_days: z.any().optional().nullable(),
  max_amount_of_simultaneous_rent: z.any().optional().nullable(),

  price_amount: z.string().optional().nullable(),

  most_read: z.boolean().optional().nullable(),
  is_pay_per_use: z.boolean().optional().nullable(),
  is_for_rent: z.boolean().optional().nullable(),
  is_for_exchange: z.boolean().optional().nullable(),
  is_for_sale: z.boolean().optional().nullable(),
  is_for_library: z.boolean().optional().nullable(),
  is_for_recurring_sale: z.boolean().optional().nullable(),
  is_best_seller: z.boolean().optional().nullable(),
  is_permanent: z.boolean().optional().nullable(),
  active: z.boolean().optional().nullable(),

  language: z.string().optional().nullable(),
  publishing_date: z.string().optional().nullable(),
});

export type BookFormValues = z.infer<typeof bookSchema>;
